const removeTrailingSlash = (path: string) => path.replace(/\/+$/, '');

const sanitizePathSlashes = (path: string) =>
  removeTrailingSlash(path.replace(/(^|[^:])\/{2,}/g, '$1/')) || '/';

export default sanitizePathSlashes;
